import { render, staticRenderFns } from "./PaymentBillingDataTeclab.vue?vue&type=template&id=33315abe"
import script from "./PaymentBillingDataTeclab.vue?vue&type=script&lang=js"
export * from "./PaymentBillingDataTeclab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports